import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { tokenExists } from '../api/auth';
import useCurrentUser from '../hooks/useCurrentUser';
import { hasAnyPermission, hasPermission } from '../utils/permissions';

const RequirePermission = ({ permissions = [], children }) => {
  const location = useLocation();
  const { user, status } = useCurrentUser();

  if (!tokenExists()) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (status === 'loading' || status === 'idle') return null;
  if (status === 'unauthorized') {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  if (status === 'error') {
    return (
      <div className="min-h-screen bg-gray-100 px-4 pt-20">
        <div role="alert" className="mx-auto max-w-lg rounded-lg border border-amber-200 bg-white p-5 shadow">
          <h1 className="text-lg font-semibold text-gray-900">No pudimos validar tu sesión</h1>
          <p className="mt-2 text-sm text-gray-600">
            Tu sesión sigue guardada, pero el servidor no respondió correctamente.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-4 rounded bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  if (!permissions.length) return children;

  if (!hasAnyPermission(user, permissions)) {
    const fallback = hasPermission(user, 'branch.read') ? '/branches' : '/home';
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default RequirePermission;
